import { EDIT_ADDRESS_ATTEMPT, EDIT_ADDRESS_SUCCESS, EDIT_ADDRESS_FAILED } from '../types'
import axios from 'axios';
export const editaddress = ({ nameEdit, mobileEdit, catId, addressId, userId}) => {

    return (dispatch) => {
        dispatch({ type: EDIT_ADDRESS_ATTEMPT });
        //call the backend
            axios.post('https://zliten.onwan.ly/API/addresses/editAddress.php', { nameEdit, mobileEdit, catId,addressId, userId })
             .then((resp) => handleResponse(dispatch, resp.data)) 
            /* .then((resp) => console.log(resp.data))*/
            .catch(error => console.error(error));
    }
}

const handleResponse = (dispatch, data) => {    
    if (data.success !== true) {
        onFailed(dispatch, data.message, data.success)
        console.log('Failed')
        console.log(data)
    } else {
        onSuccess(dispatch, data.message, data.success )
        console.log('Success')
        console.log(data)
    }
}
const onSuccess = (dispatch, message, success) => {
    dispatch({ type: EDIT_ADDRESS_SUCCESS, message: message , success: success })
}

const onFailed = (dispatch,  message, success) => {
    dispatch({ type: EDIT_ADDRESS_FAILED,  message: message , success: success  })
}